import HBSwiper from "@/components/HBSwiper";
import { getSeoKeywordList } from "@/services/qingzhou";
import { serverSideNotFound } from "@/utils/server/serverSide";
import { Button, Pagination } from "antd";
import classNames from "classnames";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useMemo } from "react";
import { When } from "react-if";
import styles from "./index.module.less";
// 一页100条
const PAGE_SIZE = 100;
// 第二层分页最多50页
const SECOND_PAGE_MAX = 50;
const headInfo = {
  pin: {
    title: "最新采集图片素材下载_花瓣网",
    desc: "花瓣网最新采集图片设计灵感图，一键收藏下载。",
    key: "采集图片, 采集素材, 设计素材下载",
    h1: "采集",
  },
  board: {
    title: "最新画板资源下载_花瓣网",
    desc: "花瓣网最新画板资源，一键收藏下载。",
    key: "画板图片, 画板素材, 画板素材下载",
    h1: "画板",
  },
  material: {
    title: "最新素材资源下载_花瓣网",
    desc: "花瓣网最新素材资源，一键收藏下载。",
    key: "素材图片, 设计素材下载",
    h1: "素材",
  },
};
export default function getInLinksPage(categroy) {
  return {
    PageComponent({ keywordList, pageTitle, total = 0 }) {
      const router = useRouter();
      const { num: page = 1 } = router.query;
      const firstPage = Math.ceil(+page / SECOND_PAGE_MAX);
      const secondPage = +page % SECOND_PAGE_MAX || SECOND_PAGE_MAX;
      // 第二层分页的总数
      const secondPageTotal = useMemo(() => {
        const totalNum = Math.ceil(total / (SECOND_PAGE_MAX * PAGE_SIZE));
        const current = Math.ceil(+page / SECOND_PAGE_MAX);

        return current === totalNum
          ? total % (SECOND_PAGE_MAX * PAGE_SIZE)
          : SECOND_PAGE_MAX * PAGE_SIZE;
      }, [page, total]);

      // 第一行分页
      const list = useMemo(() => {
        const totalNum = Math.ceil(total / (SECOND_PAGE_MAX * PAGE_SIZE));
        const list = [];
        for (let i = 0; i < totalNum; i++) {
          list.push(
            <Link
              href={`/topic-${categroy}/page/${i * SECOND_PAGE_MAX + 1}`}
              key={i}
            >
              <a
                className={classNames(styles.item, {
                  [styles.active]: firstPage == i + 1,
                })}
              >
                {i + 1}
              </a>
            </Link>
          );
        }
        return list;
      }, [firstPage, total]);

      return (
        <div className="calculateWrapper">
          <When condition={headInfo[categroy]}>
            <Head>
              <title>{headInfo[categroy]?.title}</title>
              <meta name="keywords" content={headInfo[categroy]?.key} />
              <meta name="description" content={headInfo[categroy]?.desc} />
            </Head>
          </When>
          <div className="golbalHiddenH1">
            <h1>{headInfo[categroy]?.h1}</h1>
          </div>
          <div className={styles.pageTitle}>{pageTitle}</div>
          <HBSwiper
            className={classNames(styles.firstPages)}
            iconClassName={styles.swiperIcon}
            contentClassName={styles.swiperContent}
          >
            {list}
          </HBSwiper>
          <div className={styles.listWrap}>
            {keywordList.map((word) => (
              <Link key={word.alias} href={`/topic-${categroy}/${word.alias}`}>
                <a className={styles.item}>
                  <Button type="text" title={word.keyword}>
                    <span className={styles.text}>{word.keyword}</span>
                  </Button>
                </a>
              </Link>
            ))}
          </div>
          {total > PAGE_SIZE && (
            <div className={styles.pagination}>
              <Pagination
                current={secondPage}
                total={secondPageTotal}
                pageSize={PAGE_SIZE}
                onChange={() => {}}
                showSizeChanger={false}
                itemRender={(page, type, originalElement) => {
                  return (
                    <Link
                      href={`/topic-${categroy}/page/${
                        (firstPage - 1) * SECOND_PAGE_MAX + page
                      }`}
                    >
                      {React.cloneElement(originalElement, { rel: "" })}
                    </Link>
                  );
                }}
              />
            </div>
          )}
        </div>
      );
    },

    async getServerSideProps({ res: nextRes, params }) {
      try {
        const { num: page = 1 } = params || {};
        const categroyMap = {
          board: "画板",
          pin: "采集",
          user: "用户",
          material: "素材",
        };

        if (categroyMap[categroy] === undefined) {
          return serverSideNotFound(nextRes);
        }
        const res = await getSeoKeywordList({
          // initial: "A",
          category_code: `topic-${categroy}`,
          page_num: page,
          page_size: PAGE_SIZE,
        });

        if (res?.message) {
          console.error("getSeoKeywordList request error", res.message);
        }

        return {
          props: {
            keywordList: res.data || [],
            total: res?.pagination?.total || 0,
            pageTitle: categroyMap[categroy],
          },
        };
      } catch (error) {
        return { props: { keywordList: [] } };
      }
    },
  };
}
